export default "__VITE_ASSET__CRr_D_tv__"